import validate from "/usr/src/app/content/n3-treatments-ec1f2160-ad7f-40bd-9358-2d7751df271e/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-ec1f2160-ad7f-40bd-9358-2d7751df271e/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}